<div class="container">
    <div class="clear40"></div>
    <div class="text-center">
        <img class="logo" src="./assets/images/logo1.png">
        <div class="clear30"></div>
        <h3 class="txt-blue semi-bold">Welcome to MyTL</h3>
        <div class="clear30"></div>
        <div [hidden]="Type === 'Office Admin Staff'">
            <div class="fs-18 regular blue text-center">To partner with Travelance, follow the 4-step broker sign-up process:</div>
        <div class="clear10"></div>
        <div class="fs-18 regular blue text-center">
            <ol>
                <li>Confirm Personal Info</li>
                <li>Upload Documents</li>
                <li>Sign Agreement</li>
                <li>Complete Online Training</li>
              </ol> 
        </div>
        <div class="fs-18 regular blue text-center">Once approved, the Travelance online sales portal and additional online training modules will become available through MyTL.</div>
        <!-- <div class="fs-18 regular blue text-center"></div> -->
        <div class="clear10"></div>
        <div class="fs-18 regular blue text-center">Designated Administrative Reps will be able to access their agency’s ‘Office Admin Dashboard’.</div>

        </div>
        <!-- <h6 class="fs-18 regular blue" [hidden]="Type === 'Office Admin Staff'">To partner with Travelance, follow the 4-step broker sign-up process. Once approved, the Travelance online sales portal and additional online training modules will become available through MyTL.</h6>
        <br>
        <h6 class="fs-18 regular blue" [hidden]="Type === 'Office Admin Staff'">Designated Administrative Reps will be able to access their agency’s ‘Office Admin Dashboard’.</h6> -->
        <h6 class="fs-18 regular blue" *ngIf="Type === 'Office Admin Staff'">To access the MyTL portal and administer your agency's brokers, please confirm your contact information.</h6>

        <!-- <div class="clear40"></div> -->
        <div class="line"></div>


        <div class="row">

            <div *ngFor="let item of dashboardList" class="col-sm-3 col-md-3 col-lg-3 col-12">
                <div *ngIf="item.displayName=='Pending Personal Info'">
                    <div class="card card-box">
                        <div class="card-body">
                            <img src="./assets/images/personal.png">
                            <div class="clear30"></div>
                            <h6 class="semi-bold txt-black1">Personal Info</h6>

                        </div>
                    </div>
                    <div class="clear10"></div>
                    <button *ngIf="item.isCompleted==false" type="button" class="btn btn-pink">PENDING</button>
                    <button *ngIf="item.isCompleted==true" type="button" class="btn btn-pink">COMPLETED</button>
                </div>
                <div *ngIf="item.displayName=='Pending Upload Documents'">
                    <div class="card card-box">
                        <div class="card-body">
                            <img src="./assets/images/upload.png">
                            <div class="clear30"></div>
                            <h6 class="semi-bold txt-black1">Upload Documents</h6>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <button *ngIf="item.isCompleted==false" type="button" class="btn btn-pink">PENDING</button>
                    <button *ngIf="item.isCompleted==true" type="button" class="btn btn-pink">COMPLETED</button>

                </div>
                <div *ngIf="item.displayName=='Pending Contract Sign'">
                    <div class="card card-box">
                        <div class="card-body">
                            <img src="./assets/images/contract.png">
                            <div class="clear30"></div>
                            <h6 class="semi-bold txt-black1">Agreement Sign</h6>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <button *ngIf="item.isCompleted==false" type="button" class="btn btn-pink">PENDING</button>
                    <button *ngIf="item.isCompleted==true" type="button" class="btn btn-pink">COMPLETED</button>

                </div>
                <div *ngIf="item.displayName=='Pending ONLINE_TRAINING'">
                    <div class="card card-box">
                        <div class="card-body">
                            <img src="./assets/images/training.png">
                            <div class="clear30"></div>
                            <h6 class="semi-bold txt-black1">Online Training</h6>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <button *ngIf="item.isCompleted==false" type="button" class="btn btn-pink">PENDING</button>
                    <button *ngIf="item.isCompleted==true" type="button" class="btn btn-pink">COMPLETED</button>

                </div>
            </div>




        </div>
        <div class="clear30"></div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
            <button type="button" class="btn btn-blue mt-4" routerLink="/dashboard/personal-info" [hidden]="Type === 'Office Admin Staff'">Start the Sign-Up Process<span class="float-right"><img src="./assets/images/rightarrow.png" /></span></button>
            <button type="button" class="btn btn-blue mt-4" routerLink="/dashboard/personal-info" *ngIf="Type === 'Office Admin Staff'">Continue<span class="float-right"><img src="./assets/images/rightarrow.png" /></span></button>
        </div>


    </div>
</div>